import _construct from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import chroma from '../../chroma.js';
import Color from '../../Color.js';
import input from '../input.js';
import { unpack, type } from '../../utils/index.js';
var round = Math.round;
Color.prototype.rgb = function () {
  var rnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  if (rnd === false) return this._rgb.slice(0, 3);
  return this._rgb.slice(0, 3).map(round);
};
Color.prototype.rgba = function () {
  var rnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return this._rgb.slice(0, 4).map(function (v, i) {
    return i < 3 ? rnd === false ? v : round(v) : v;
  });
};
var rgb = function rgb() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return _construct(Color, args.concat(['rgb']));
};
Object.assign(chroma, {
  rgb: rgb
});
input.format.rgb = function () {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var rgba = unpack(args, 'rgba');
  if (rgba[3] === undefined) rgba[3] = 1;
  return rgba;
};
input.autodetect.push({
  p: 3,
  test: function test() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    args = unpack(args, 'rgba');
    if (type(args) === 'array' && (args.length === 3 || args.length === 4 && type(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) {
      return 'rgb';
    }
  }
});
export { rgb };